// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

// Third-Party Libraries
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ToastrModule } from "ngx-toastr";
import { CookieModule } from "ngx-cookie";
import { Angulartics2Module } from "angulartics2";
import { Angulartics2GoogleTagManager } from "angulartics2/gtm";
import { Angulartics2GoogleAnalytics } from "angulartics2/ga";
import { Angulartics2Segment } from "angulartics2/segment";

// Base
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Services
import { AnalyticsService } from "./services/analytics.service";
import { AnswersService } from "./services/answer.service";
import { AssessmentService } from "./services/assessment.service";
import { AuthService } from "./services/auth.service";
import { ContentService } from "./services/content.service";
import { CRDSSiteService } from "./services/crossroads.site.service";
import { DataService } from "./services/data.service";
import { PreLoaderService } from "./components/preloader/preloader.service";
import { StateService } from "./services/state.service";

// Pipes
import { SafeHtmlPipe } from "./pipes/safe_html.pipe";

// Guards
import { QuestionGuard } from "./route-guards/question.guard";
import { OpenResponseGuard } from "./route-guards/openresponse.guard";
import { StopAndBreatheGuard } from "./route-guards/stopbreathe.guard";

// Components
import { ContentComponent } from "./components/content/content.component";
import { FinalquestionPageComponent } from "./components/finalquestion-page/finalquestion-page.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { HomeComponent } from "./components/home/home.component";
import { InfoPageComponent } from "./components/info-page/info-page.component";
import { InstructionsComponent } from "./components/instructions/instructions.component";
import { PreLoaderComponent } from "./components/preloader/preloader.component";
import { QuestionComponent } from "./components/question/question.component";
import { QuestionFormComponent } from "./components/question-form/question-form.component";
import { QuestionProgressBarComponent } from "./components/question-progress-bar/question-progress-bar.component";
import { QuestionMarkupComposerComponent } from "./components/question-markup-composer/question-markup-composer.component";
import { ResultsComponent } from "./components/results/results.component";
import { ResultsChartComponent } from "./components/results-chart/results-chart.component";
import { ResultsOverviewComponent } from "./components/results-overview/results-overview.component";
import { ResultsOverviewDetailComponent } from "./components/results-overview-detail/results-overview-detail.component";
import { ResumeConfirmationComponent } from "./components/resume-confirmation/resume-confirmation.component";
import { ThankyouComponent } from "./components/thankyou/thankyou.component";
import { StopAndBreatheComponent } from "./components/stop-and-breathe/stop-and-breathe.component";
import { OpenResponseComponent } from "./components/open-response/open-response.component";
import { FAQComponent } from "./components/faq/faq.component";
import { DebounceClickDirective } from "./directives/debounce-click.directive";
import { AudioPlayerComponent } from "./components/audio-player/audio-player.component";
import { GraphQLModule } from "./graphql.module";

@NgModule({
  declarations: [
    AppComponent,
    ContentComponent,
    FinalquestionPageComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    InfoPageComponent,
    QuestionComponent,
    QuestionFormComponent,
    QuestionMarkupComposerComponent,
    QuestionProgressBarComponent,
    ResultsChartComponent,
    ResultsComponent,
    SafeHtmlPipe,
    PreLoaderComponent,
    ResultsOverviewComponent,
    ResultsOverviewDetailComponent,
    ResumeConfirmationComponent,
    InstructionsComponent,
    ThankyouComponent,
    StopAndBreatheComponent,
    OpenResponseComponent,
    FAQComponent,
    DebounceClickDirective,
    AudioPlayerComponent
  ],
  imports: [
    AccordionModule.forRoot(),
    Angulartics2Module.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ButtonsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    TooltipModule.forRoot(),
    CookieModule.forRoot(),
    HttpClientModule,
    GraphQLModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AnalyticsService,
    Angulartics2GoogleAnalytics,
    Angulartics2GoogleAnalytics,
    Angulartics2Segment,
    AnswersService,
    AssessmentService,
    AnswersService,
    AuthService,
    DataService,
    ContentService,
    CRDSSiteService,
    OpenResponseGuard,
    PreLoaderService,
    QuestionGuard,
    StateService,
    HttpClientModule,
    StopAndBreatheGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {}
}
